import { useQuery } from "@tanstack/react-query";

import {
  getOperationPackageCountInProgress,
  getOperationPackagePatterns,
  getOperationPackages,
  postOperationPackagePatterns,
} from "@/features/operation-packages/api";

import { PACKAGE_TYPE_TO_GROUP } from "../-constants";

import type { ItOperationCorePackages } from "./type";

// グルーピングロジックを含むAPI実装
export async function listOperationPackages(): Promise<ItOperationCorePackages> {
  const packages = await getOperationPackages("IT_OPERATION_CORE");

  // 並列で件数を取得
  const packagesWithCount = await Promise.all(
    packages.map(async (pkg) => {
      const { count } = await getOperationPackageCountInProgress(
        "IT_OPERATION_CORE",
        pkg.operationPackageId,
      );
      return {
        id: pkg.operationPackageId,
        type: pkg.packageType,
        name: pkg.name,
        description: pkg.description ?? undefined,
        instanceCount: count,
      };
    }),
  );

  // グルーピング
  const result: ItOperationCorePackages = {
    apps: [],
    devices: [],
    sharedDrive: [],
    network: [],
  };

  for (const pkg of packagesWithCount) {
    const group = PACKAGE_TYPE_TO_GROUP[pkg.type];
    if (group) {
      result[group].push(pkg);
    }
    // マッピングがないものは無視
  }

  return result;
}

export function useItOperationPackages() {
  return useQuery({
    queryKey: ["it-operation-packages"],
    queryFn: listOperationPackages,
  });
}

export function listPackagePatterns(packageId: string) {
  return getOperationPackagePatterns("IT_OPERATION_CORE", packageId);
}

export function createPattern(packageId: string) {
  return postOperationPackagePatterns("IT_OPERATION_CORE", packageId);
}

export function createPatternManual(
  packageId: string,
  body: { name: string; description?: string },
) {
  return postOperationPackagePatterns("IT_OPERATION_CORE", packageId, body);
}
